import { APIResponse, BrandData } from '../../@types';
import { makeAPICall } from './clientHelpers/makeAPICall';

export const brandClient = {
  getSettings: async (): Promise<APIResponse<BrandData>> => {
    const { data, error } = await makeAPICall({
      method: 'GET',
      url: '/brand',
      checkModified: false,
    });
    return {
      data,
      error,
    };
  },
};
